import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Sidebar from "@/components/Sidebar";
import Overview from "@/pages/Overview";
import Mappings from "@/pages/Mappings";
import Pool from "@/pages/Pool";
import Users from "@/pages/Users";
import BurnList from "@/pages/BurnList";
import VCards from "@/pages/VCards";
import Logs from "@/pages/Logs";
import Simulator from "@/pages/Simulator";
import InviteCodes from "@/pages/InviteCodes";
import ProxyPool from "@/pages/ProxyPool";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfService from "@/pages/legal/TermsOfService";
import SMSTerms from "@/pages/legal/SMSTerms";
import LandingPage from "@/pages/LandingPage";
import SignupPage from "@/pages/SignupPage";
import SignupSuccess from "@/pages/SignupSuccess";
import api from "@/lib/api";

function AdminShell() {
  useEffect(() => {
    api.ping().catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex bg-[#09090b] text-white">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-10">
          <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/mappings" element={<Mappings />} />
            <Route path="/pool" element={<Pool />} />
            <Route path="/users" element={<Users />} />
            <Route path="/burn" element={<BurnList />} />
            <Route path="/vcards" element={<VCards />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/simulator" element={<Simulator />} />
            <Route path="/invites" element={<InviteCodes />} />
            <Route path="/proxy-pool" element={<ProxyPool />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/signup/success" element={<SignupSuccess />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/sms-terms" element={<SMSTerms />} />
          {/* Admin dashboard */}
          <Route path="/admin/*" element={<AdminShell />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0e0e10",
              border: "1px solid #27272a",
              color: "#fafafa",
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "12px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
